import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CircleCheckBigIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/landing';
export function FloatingCta() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const target = document.getElementById('first-cta');
    if (!target) return;
    const observer = new IntersectionObserver(([entry]) => {
      setVisible(!entry.isIntersecting && entry.boundingClientRect.top < 0);
    });
    observer.observe(target);
    return () => observer.disconnect();
  }, []);
  return <div className="pointer-events-none fixed inset-x-0 bottom-0 z-40 flex justify-center md:bottom-5" data-id="element-34" data-mp="gp3wpoe2qqir">
    <AnimatePresence data-id="element-35" data-mp="brkhal5n47p8">
      {visible && <motion.div initial={{
        y: 100,
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} exit={{
        y: 100,
        opacity: 0
      }} transition={{
        duration: 0.25,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto w-full border-t border-navy/10 bg-white/95 px-3 pb-[max(12px,env(safe-area-inset-bottom))] pt-3 backdrop-blur md:w-[520px] md:rounded-2xl md:border md:shadow-xl" data-id="element-36" data-mp="boolb2dcrt3f">
          <a href={CHECKOUT_URL} className="animate-shake flex w-full items-center justify-center gap-2 rounded-xl bg-cta px-4 py-4 text-[16px] font-extrabold uppercase tracking-wide text-white shadow-[0_4px_0_0_#166534] focus:outline-none focus-visible:ring-4 focus-visible:ring-sky-light" data-id="element-37" data-mp="21cvwuzfkpnb3">
            <CircleCheckBigIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-38" data-mp="1wem1anpxskoy" />
            <span className="whitespace-nowrap" data-id="element-39" data-mp="1ieb83e15mu0m">Get it now for $27</span>
          </a>
        </motion.div>}
    </AnimatePresence>
    </div>;
}